import { useFeatureFlagEnabled } from '@posthog/react';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import PlatformLink from '@/components/common/PlatformLink';
import SubPageHeader from '@/components/common/SubPageHeader';
import { Button } from '@/components/shadcn/button';

import AutoConceptReplySetting from './components/AutoConceptReplySetting';
import DarkModeSetting from './components/DarkModeSetting';
import DevSettings from './components/DevSettings';
import FeedbackButton from './components/FeedbackButton';
import LanguageSetting from './components/LanguageSetting';
import OutlookSetting from './components/OutlookSetting';
import ScaleSetting from './components/ScaleSetting';
import UserCard from './components/UserCard';

export default function Settings() {
  const { t } = useTranslation();
  const isOutlookSSOEnabled = useFeatureFlagEnabled('outlook-sso');

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>
        <div className="flex w-full items-center justify-between">
          {t('SETTINGS_TITLE')}
        </div>
      </SubPageHeader>

      <main className="flex-1 overflow-y-auto">
        <div className="flex flex-col gap-3 p-2">
          <UserCard />

          <div className="flex flex-col gap-4 px-2">
            <DarkModeSetting />

            <LanguageSetting />

            <ScaleSetting />

            <AutoConceptReplySetting />

            {isOutlookSSOEnabled && <OutlookSetting />}

            <Button asChild>
              <PlatformLink
                to="/settings/account/general-information"
                target="_blank"
              >
                {t('MORE_SETTINGS_BUTTON')}

                <ExternalLink />
              </PlatformLink>
            </Button>

            <FeedbackButton />
          </div>
        </div>

        <DevSettings />
      </main>
    </div>
  );
}
